<script setup>
import CommonSwatch from "../common/Swatch.vue";
import { useHandleImageSwitcher } from "../../composeables/useHandleImageSwitcher";

const props = defineProps({
	colours: {
		type: Array,
		required: true,
	},
});

const currentProductBasket = defineModel();
const { setImage } = useHandleImageSwitcher();

const handleColourChange = (newColour) => {
	let colourExistsInBasket = false;
	currentProductBasket.value.products.map((product) => {
		if (product.id === newColour.id) colourExistsInBasket = true;
	});

	if (colourExistsInBasket) return;

	currentProductBasket.value.products.push({
		...newColour,
		products: [],
	});

	if (typeof newColour.image === "string") {
		setImage(newColour.image);
	} else if (newColour.image.gallery_thumbnail_src) {
		setImage(newColour.image.gallery_thumbnail_src);
	}
};
</script>

<template>
	<div class="u-flex u-wrap u-gap-half">
		<template v-for="colour in colours">
			<CommonSwatch
				:data="colour"
				@click="handleColourChange(colour)"
				:productsInBasket="currentProductBasket.products"
			/>
		</template>
	</div>
</template>
